import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from './router.config.js'
import { isObject } from 'lodash/lang'

// hack router push callback
const originalPush = Router.prototype.push
Router.prototype.push = function push (params){
  if (isObject(params)) {
    return originalPush.call(this, {...params}).catch(err => err)
  } else {
    return originalPush.call(this, params).catch(err => err)
  }

}

Vue.use(Router)

const createRouter = () =>
  new Router({
    mode: 'history', // 如果你是 history模式 需要配置vue.config.js publicPath
    // mode: 'hash',
    // base: process.env.BASE_URL,
    base:'/',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
